const CITIES = {
  paris: {
    id: 'paris',
    name: 'Paris',
    title: 'HEARTS IN PARIS',
    titleSuffix: 'IN PARIS',
    totalHearts: 1000,
    subtitle: "qargo inonde Paris d'amour",
    description: "1000 cœurs en LEGO cachés dans Paris pour la Journée Mondiale de l'Art le 15 avril 2026",
    country: 'France',
    geocodeSuffix: 'Paris, France',
    mapCenter: [48.8566, 2.3522],
    mapZoom: 12,
    gridCols: 47,
    gridRows: 43,
    date: '15 avril 2026',
    event: "Journée Mondiale de l'Art",
    heroBg: 'https://static.prod-images.emergentagent.com/jobs/d968817f-a6dd-4b35-a9b8-6f8634275a04/images/4cff68ed62e1357f878f0565aab5d76743ede8b4fdd136d958e4422d6047f1c6.png',
    photonCenter: { lat: 48.856, lon: 2.347 },
    photonBbox: '2.224,48.815,2.470,48.903',
    photonCityMatchers: ['paris'],
    searchPlaceholder: 'Pigalle, 7 rue de Rivoli, Tour Eiffel...',
    places: [
      { name: 'Pigalle', lat: 48.8823, lon: 2.3381 },
      { name: 'Montmartre', lat: 48.8867, lon: 2.3431 },
      { name: 'Le Marais', lat: 48.8566, lon: 2.3622 },
      { name: 'Bastille', lat: 48.8533, lon: 2.3692 },
      { name: 'République', lat: 48.8675, lon: 2.3636 },
      { name: 'Châtelet', lat: 48.8584, lon: 2.3474 },
      { name: 'Les Halles', lat: 48.8622, lon: 2.3453 },
      { name: 'Opéra', lat: 48.8719, lon: 2.3316 },
      { name: 'Saint-Germain-des-Prés', lat: 48.8540, lon: 2.3338 },
      { name: 'Saint-Michel', lat: 48.8534, lon: 2.3443 },
      { name: 'Belleville', lat: 48.8714, lon: 2.3769 },
      { name: 'Ménilmontant', lat: 48.8660, lon: 2.3838 },
      { name: 'Oberkampf', lat: 48.8648, lon: 2.3689 },
      { name: 'Nation', lat: 48.8485, lon: 2.3960 },
      { name: 'Père Lachaise', lat: 48.8614, lon: 2.3934 },
      { name: 'Place des Vosges', lat: 48.8556, lon: 2.3655 },
      { name: 'Tour Eiffel', lat: 48.8584, lon: 2.2945 },
      { name: 'Trocadéro', lat: 48.8627, lon: 2.2876 },
      { name: 'Champs-Élysées', lat: 48.8698, lon: 2.3076 },
      { name: 'Arc de Triomphe', lat: 48.8738, lon: 2.2950 },
      { name: 'Sacré-Coeur', lat: 48.8867, lon: 2.3431 },
      { name: 'Notre-Dame', lat: 48.8530, lon: 2.3499 },
      { name: 'Louvre', lat: 48.8606, lon: 2.3376 },
      { name: "Musée d'Orsay", lat: 48.8600, lon: 2.3266 },
      { name: 'Centre Pompidou', lat: 48.8607, lon: 2.3525 },
      { name: 'Canal Saint-Martin', lat: 48.8717, lon: 2.3653 },
      { name: 'Jardin du Luxembourg', lat: 48.8462, lon: 2.3372 },
      { name: 'Jardin des Tuileries', lat: 48.8634, lon: 2.3275 },
      { name: 'Parc des Buttes-Chaumont', lat: 48.8809, lon: 2.3826 },
      { name: 'Gare du Nord', lat: 48.8809, lon: 2.3553 },
      { name: 'Gare de Lyon', lat: 48.8443, lon: 2.3742 },
      { name: 'Gare Saint-Lazare', lat: 48.8762, lon: 2.3250 },
      { name: 'La Villette', lat: 48.8938, lon: 2.3908 },
      { name: 'Bercy', lat: 48.8399, lon: 2.3826 },
      { name: "Place d'Italie", lat: 48.8312, lon: 2.3553 },
      { name: 'Denfert-Rochereau', lat: 48.8339, lon: 2.3326 },
      { name: 'Batignolles', lat: 48.8837, lon: 2.3192 },
      { name: 'Barbès', lat: 48.8848, lon: 2.3494 },
      { name: 'Stalingrad', lat: 48.8842, lon: 2.3685 },
      { name: 'Rue de Rivoli', lat: 48.8562, lon: 2.3481 },
      { name: 'Rue Mouffetard', lat: 48.8428, lon: 2.3497 },
      { name: 'Rue Oberkampf', lat: 48.8657, lon: 2.3745 },
      { name: 'Boulevard Saint-Germain', lat: 48.8530, lon: 2.3390 },
      { name: 'Boulevard Haussmann', lat: 48.8741, lon: 2.3318 },
      { name: 'Rue de la Roquette', lat: 48.8560, lon: 2.3742 },
      { name: 'Rue des Martyrs', lat: 48.8802, lon: 2.3397 },
      { name: 'Rue du Faubourg Saint-Antoine', lat: 48.8510, lon: 2.3763 },
      { name: 'Place de la Concorde', lat: 48.8656, lon: 2.3212 },
      { name: 'Place du Tertre', lat: 48.8864, lon: 2.3408 },
      { name: 'Île de la Cité', lat: 48.8554, lon: 2.3473 },
      { name: 'Île Saint-Louis', lat: 48.8516, lon: 2.3567 },
    ],
  },
  lille: {
    id: 'lille',
    name: 'Lille',
    title: 'HEARTS IN LILLE',
    titleSuffix: 'IN LILLE',
    totalHearts: 100,
    subtitle: "qargo inonde Lille d'amour",
    description: "100 cœurs en LEGO cachés dans Lille\nle 12 juin 2026 en marge de Solidart.",
    country: 'France',
    geocodeSuffix: 'Lille, France',
    mapCenter: [50.6292, 3.0573],
    mapZoom: 13,
    gridCols: 14,
    gridRows: 11,
    heartPattern: [
      '..XXX....XXX..',
      '.XXXXX..XXXXX.',
      'XXXXXXXXXXXXXX',
      'XXXXXXXXXXXXXX',
      'XXXXXXXXXXXXXX',
      '.XXXXXXXXXXXX.',
      '..XXXXXXXXXX..',
      '...XXXXXXXX...',
      '....XXXXXX....',
      '.....XXXX.....',
      '......XX......',
    ],
    date: '12 juin 2026',
    event: 'Salon Solidart Lille',
    heroBg: '/hero-lille-skyline.png',
    photonCenter: { lat: 50.6292, lon: 3.0573 },
    // Bbox couvre Lille + Lomme + Hellemmes + La Madeleine + Marcq + Roubaix + Tourcoing + Villeneuve d'Ascq
    photonBbox: '2.95,50.55,3.25,50.74',
    photonCityMatchers: ['lille', 'lomme', 'hellemmes'],
    searchPlaceholder: 'Grand Place, Vieux Lille, Citadelle...',
    places: [
      { name: 'Grand Place', lat: 50.6371, lon: 3.0635 },
      { name: 'Place du Général de Gaulle', lat: 50.6371, lon: 3.0635 },
      { name: 'Vieux Lille', lat: 50.6420, lon: 3.0620 },
      { name: 'Place du Théâtre', lat: 50.6378, lon: 3.0644 },
      { name: 'Place Rihour', lat: 50.6356, lon: 3.0620 },
      { name: 'Place Louise de Bettignies', lat: 50.6415, lon: 3.0660 },
      { name: 'Place aux Oignons', lat: 50.6418, lon: 3.0610 },
      { name: 'Opéra de Lille', lat: 50.6382, lon: 3.0649 },
      { name: 'Vieille Bourse', lat: 50.6374, lon: 3.0641 },
      { name: 'Beffroi de Lille', lat: 50.6342, lon: 3.0633 },
      { name: "Palais des Beaux-Arts", lat: 50.6313, lon: 3.0628 },
      { name: 'Citadelle de Lille', lat: 50.6444, lon: 3.0500 },
      { name: 'Parc de la Citadelle', lat: 50.6440, lon: 3.0530 },
      { name: 'Porte de Paris', lat: 50.6314, lon: 3.0680 },
      { name: 'Gare Lille Flandres', lat: 50.6364, lon: 3.0703 },
      { name: 'Gare Lille Europe', lat: 50.6388, lon: 3.0747 },
      { name: 'Euralille', lat: 50.6385, lon: 3.0734 },
      { name: 'Rue de Béthune', lat: 50.6342, lon: 3.0615 },
      { name: 'Rue de la Monnaie', lat: 50.6403, lon: 3.0623 },
      { name: 'Rue Esquermoise', lat: 50.6391, lon: 3.0608 },
      { name: 'Rue Faidherbe', lat: 50.6374, lon: 3.0665 },
      { name: 'Rue Nationale', lat: 50.6335, lon: 3.0575 },
      { name: 'Rue Royale', lat: 50.6420, lon: 3.0598 },
      { name: 'Rue de Gand', lat: 50.6420, lon: 3.0680 },
      { name: 'Rue Solférino', lat: 50.6320, lon: 3.0580 },
      { name: 'Rue Masséna', lat: 50.6321, lon: 3.0598 },
      { name: 'Boulevard de la Liberté', lat: 50.6320, lon: 3.0620 },
      { name: 'Quartier Wazemmes', lat: 50.6256, lon: 3.0501 },
      { name: 'Marché de Wazemmes', lat: 50.6275, lon: 3.0500 },
      { name: 'Quartier Moulins', lat: 50.6228, lon: 3.0660 },
      { name: 'Quartier Saint-Maurice', lat: 50.6310, lon: 3.0760 },
      { name: 'Quartier Vauban', lat: 50.6383, lon: 3.0508 },
      { name: 'Quartier Bois-Blancs', lat: 50.6360, lon: 3.0290 },
      { name: 'Université de Lille', lat: 50.6086, lon: 3.1392 },
      { name: 'Sciences Po Lille', lat: 50.6325, lon: 3.0570 },
      { name: 'Église Saint-Maurice', lat: 50.6356, lon: 3.0676 },
      { name: 'Cathédrale Notre-Dame-de-la-Treille', lat: 50.6410, lon: 3.0634 },
      { name: 'Maison Natale de Charles de Gaulle', lat: 50.6433, lon: 3.0584 },
      { name: 'Jardin Vauban', lat: 50.6358, lon: 3.0498 },
      { name: 'Square Foch', lat: 50.6368, lon: 3.0664 },
    ],
  },
};

const detectCity = () => {
  // 1. Env variable (highest priority)
  const envCity = process.env.REACT_APP_CITY;
  if (envCity && CITIES[envCity.toLowerCase()]) {
    return CITIES[envCity.toLowerCase()];
  }

  // 2. Detect from hostname
  const host = window.location.hostname.toLowerCase();
  if (host.includes('lille')) return CITIES.lille;

  // 3. Default to Paris
  return CITIES.paris;
};

export const cityConfig = detectCity();
export default CITIES;
